export default class FeedFilterChip {
  static ID_DELIMITER = "|";
  static TEXT_FORMAT_AS_WRITTEN = "asWritten";
  static TEXT_FORMAT_READABLE = "readable";
  static TEXT_FORMAT_DEFAULT = FeedFilterChip.TEXT_FORMAT_AS_WRITTEN;

  static #MINOR_WORDS = new Set(["a", "an", "and", "as", "at", "but", "by", "for", "in", "nor", "of", "on", "or", "the", "to", "vs", "with"]);

  static itemFor(hashtag, textFormat) {
    return {
      label: FeedFilterChip.labelFor(hashtag.value, textFormat),
      value: FeedFilterChip.valueFor(hashtag.hashtagId),
    };
  }

  static valueFor(hashtagId) {
    return `${FeedFilterChip.ID_DELIMITER}${hashtagId}${FeedFilterChip.ID_DELIMITER}`;
  }

  static labelFor(hashtag, textFormat) {
    if (textFormat === FeedFilterChip.TEXT_FORMAT_AS_WRITTEN) {
      return hashtag;
    }
    if (textFormat === FeedFilterChip.TEXT_FORMAT_READABLE) {
      return FeedFilterChip.#readableLabelFor(hashtag);
    }
    throw new FeedFilterChipError(textFormat);
  }

  static #readableLabelFor(hashtag) {
    const words = String(hashtag ?? "").replace(/^\s*#/, "").split(/[\s_-]+/).filter(word => word !== "");
    const authorChoseTheCasing = words.some(word => word !== word.toLowerCase());
    if (authorChoseTheCasing) {
      return words.join(" ");
    }
    return words.map((word, index) => FeedFilterChip.#titleCase(word, index === 0 || index === words.length - 1)).join(" ");
  }

  static #titleCase(word, isEdgeWord) {
    if (!isEdgeWord && FeedFilterChip.#MINOR_WORDS.has(word)) {
      return word;
    }
    return word.charAt(0).toUpperCase() + word.slice(1);
  }
}

class FeedFilterChipError extends Error {
  constructor(textFormat) {
    const known = [FeedFilterChip.TEXT_FORMAT_AS_WRITTEN, FeedFilterChip.TEXT_FORMAT_READABLE].join("\", \"");
    super(`Filter chip text format "${textFormat}" is not one of "${known}"`);
    this.name = "FeedFilterChipError";
    this.textFormat = textFormat;
  }
}
